import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { StyledEngineProvider } from '@mui/material/styles';
import { initializeKlaviyo } from './helpers/klaviyo';

const root = ReactDOM.createRoot(document.getElementById('react-scratch-club'));
root.render(
        <BrowserRouter>
            <StyledEngineProvider injectFirst>
            <App/>
            </StyledEngineProvider>
        </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
initializeKlaviyo();
